import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

// Styles
import styled from 'styled-components';

const Button = styled.button``;

/**
 * Basic icon button used throughout the app.
 *
 * @param {Component} icon
 * @param {string} className
 * @param {func} onClick
 */

const IconButton = forwardRef(function IconButton(
  { icon, onClick, className, id },
  passedRef,
) {
  return (
    <Button id={id} ref={passedRef} className={className} onClick={onClick}>
      {icon}
    </Button>
  );
});

IconButton.propTypes = {
  id: PropTypes.string,
  icon: PropTypes.element,
  onClick: PropTypes.func,
  className: PropTypes.string,
  passedRef: PropTypes.object,
};

export default IconButton;
